import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "cardbody" }
const _hoisted_6 = { class: "flex flex-row-reverse items-center" }
const _hoisted_7 = { class: "flex flex-row-reverse items-center" }
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex flex-col h-full" }
const _hoisted_12 = { class: "flex-1 overflow-auto" }
const _hoisted_13 = { class: "border-0 rounded relative flex flex-col w-full bg-white risksAcceptance h-screen" }
const _hoisted_14 = { class: "flex items-center justify-between rounded popupheadingcontainer" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_22 = { class: "formcontainer flex flex-col" }
const _hoisted_23 = { class: "row flex flex-col" }
const _hoisted_24 = { class: "upperspacing" }
const _hoisted_25 = {
  key: 0,
  class: "controllabel"
}
const _hoisted_26 = {
  key: 1,
  class: "controllabel"
}
const _hoisted_27 = {
  key: 2,
  class: "controllabel"
}
const _hoisted_28 = { class: "text-xs flex flex-wrap" }
const _hoisted_29 = { class: "w-full upperspacing" }
const _hoisted_30 = {
  key: 0,
  class: "controllabel"
}
const _hoisted_31 = {
  key: 1,
  class: "controllabel"
}
const _hoisted_32 = {
  key: 2,
  class: "controllabel"
}
const _hoisted_33 = {
  key: 3,
  class: "controllabel"
}
const _hoisted_34 = {
  key: 4,
  class: "controllabel"
}
const _hoisted_35 = {
  key: 5,
  class: "controllabel"
}
const _hoisted_36 = {
  key: 6,
  class: "text-red-500"
}
const _hoisted_37 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_40 = { class: "col-md-6 w-6/12" }
const _hoisted_41 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_42 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_43 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_44 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_45 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_46 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_47 = { class: "col-md-6 w-6/12" }
const _hoisted_48 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_49 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_50 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_51 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_52 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_53 = { class: "w-6/12 upperspacing" }
const _hoisted_54 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_55 = { class: "w-6/12" }
const _hoisted_56 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_57 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_58 = { class: "w-6/12 upperspacing" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_61 = { class: "col-md-6 w-6/12" }
const _hoisted_62 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_63 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_64 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_65 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_66 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_67 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_68 = { class: "col-md-6 w-6/12" }
const _hoisted_69 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_70 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_71 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_72 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_73 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_74 = { class: "w-6/12 upperspacing" }
const _hoisted_75 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_76 = { class: "w-6/12" }
const _hoisted_77 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_78 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_79 = { class: "w-6/12 upperspacing" }
const _hoisted_80 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = ["disabled"]
const _hoisted_83 = ["disabled"]
const _hoisted_84 = ["disabled"]
const _hoisted_85 = ["disabled"]
const _hoisted_86 = ["disabled"]
const _hoisted_87 = ["disabled"]
const _hoisted_88 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_89 = { class: "popup-business" }
const _hoisted_90 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_91 = { class: "formcontainer flex flex-col" }
const _hoisted_92 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_93 = { class: "w-full" }
const _hoisted_94 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_95 = { class: "w-3/6" }
const _hoisted_96 = { class: "w-3/6 leftspacing" }
const _hoisted_97 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_98 = { class: "w-3/6" }
const _hoisted_99 = { class: "w-3/6 leftspacing" }
const _hoisted_100 = { class: "buttonposition flex justify-center items-center mb-4 mx-0" }
const _hoisted_101 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_102 = { class: "flex flex-col h-full" }
const _hoisted_103 = { class: "flex-1 overflow-auto" }
const _hoisted_104 = { class: "popup-business" }
const _hoisted_105 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_106 = { class: "formcontainer flex flex-col" }
const _hoisted_107 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_108 = { class: "w-full" }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_111 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_112 = { key: 1 }
const _hoisted_113 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_114 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_115 = { class: "w-3/6" }
const _hoisted_116 = { key: 0 }
const _hoisted_117 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_118 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_119 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_120 = { class: "w-3/6 leftspacing" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_123 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_124 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_125 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_126 = { class: "w-full" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_129 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_130 = { key: 1 }
const _hoisted_131 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_132 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_133 = { class: "w-3/6" }
const _hoisted_134 = { key: 0 }
const _hoisted_135 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_136 = { class: "w-3/6 leftspacing" }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_139 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_140 = { class: "w-full" }
const _hoisted_141 = { key: 0 }
const _hoisted_142 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_143 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_144 = { key: 1 }
const _hoisted_145 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_146 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_147 = { class: "w-full" }
const _hoisted_148 = { key: 0 }
const _hoisted_149 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_150 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_151 = { key: 1 }
const _hoisted_152 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_153 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_154 = { class: "w-6/12" }
const _hoisted_155 = { key: 0 }
const _hoisted_156 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_157 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_158 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_159 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_160 = { class: "w-6/12 leftspacing" }
const _hoisted_161 = { key: 0 }
const _hoisted_162 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_163 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_164 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_165 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_166 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_167 = { class: "w-6/12" }
const _hoisted_168 = { key: 0 }
const _hoisted_169 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_170 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_171 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_172 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_173 = { class: "w-6/12 leftspacing" }
const _hoisted_174 = { key: 0 }
const _hoisted_175 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_176 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_177 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_178 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_179 = { class: "w-1/2 upperspacing" }
const _hoisted_180 = { key: 0 }
const _hoisted_181 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_182 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_183 = { class: "w-1/2" }
const _hoisted_184 = { key: 0 }
const _hoisted_185 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_186 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_187 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_188 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_189 = { class: "w-6/12 upperspacing" }
const _hoisted_190 = { key: 0 }
const _hoisted_191 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_192 = ["disabled"]
const _hoisted_193 = ["disabled"]
const _hoisted_194 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_195 = { class: "flex flex-col h-full" }
const _hoisted_196 = { class: "flex-1 overflow-auto" }
const _hoisted_197 = { class: "popup-priority" }
const _hoisted_198 = { class: "w-full popupbodycontainer" }
const _hoisted_199 = { class: "w-full upperspacing" }
const _hoisted_200 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_201 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_202 = { class: "w-1/2 upperspacing" }
const _hoisted_203 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_204 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_205 = { key: 1 }
const _hoisted_206 = { class: "row flex flex-row w-full" }
const _hoisted_207 = { class: "w-full upperspacing" }
const _hoisted_208 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_209 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_210 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_211 = ["disabled"]
const _hoisted_212 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.riskName), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex", _ctx.riskAcceptanceObj.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.riskAcceptanceObj.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : (_openBlock(), _createElementBlock("img", _hoisted_9)),
              _cache[74] || (_cache[74] = _createTextVNode(" Filters "))
            ], 2)
          ])
        ])
      ])
    ]),
    _cache[150] || (_cache[150] = _createElementVNode("div", { class: "mt-3 text-xs" }, [
      _createElementVNode("div", null, " Risk management is the process of identifying, assessing and controlling financial, legal, strategic and security risks to an organization’s capital and earnings. These threats, or risks, could stem from a wide variety of sources, including financial uncertainty, legal liabilities, strategic management errors, accidents and natural disasters.To reduce risk, an organization needs to apply resources to minimize, monitor and control the impact of negative events while maximizing positive events. A consistent, systemic and integrated approach to risk management can help determine how best to identify, manage and mitigate significant risks. ")
    ], -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.riskAcceptanceObj,
        headersData: _ctx.riskHeaders,
        openPopup: true,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.applyPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          class: "applyPopup",
          popUp: _ctx.applyPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (_ctx.thisScreen == 'Acceptance')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_15, "Risk Accept"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'reset')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_16, "Risk Reset"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'deactive')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_17, "Risk Invalid"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Avoid')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_18, "Risk Avoid"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Transfer')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_19, "Risk Transfer"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Monitered')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_20, "Risk Moniter"))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCrossbtn()))
                    }, _cache[75] || (_cache[75] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ]),
                  _cache[103] || (_cache[103] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              (_ctx.systemHead)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_25, "Systems"))
                                : _createCommentVNode("", true),
                              (_ctx.processHead)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_26, "Process"))
                                : _createCommentVNode("", true),
                              (_ctx.organizationHead)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_27, "Organization"))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_28, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainSystemBind, (obj, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "mr-2 mb-2 bg-primary text-white px-2 py-1 rounded fontStyle"
                                  }, _toDisplayString(obj.label), 1))
                                }), 128))
                              ])
                            ]),
                            _cache[102] || (_cache[102] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey upperspacing" }, null, -1)),
                            _createElementVNode("div", _hoisted_29, [
                              (_ctx.thisScreen == 'Acceptance')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_30, "Treatment Summary for Accepting Risk"))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'reset')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_31, "Treatment Summary for Reset Risk"))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'deactive')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_32, "Treatment Summary for Invalid Risk"))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'Avoid')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_33, "Treatment Summary for Avoid Risk "))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'Transfer')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_34, "Treatment Summary for Transfer Risk "))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'Monitered')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_35, "Treatment Summary for Monitered Risk"))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("textarea", {
                                type: "text",
                                class: _normalizeClass(["inputboxstyling h-20 max-h-48", {
                                                    'is-invalid': (_ctx.v$.applyObj.comments.$error)
                                                }]),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.applyObj.comments) = $event)),
                                placeholder: "Treatment Summary"
                              }, "                                            ", 2), [
                                [
                                  _vModelText,
                                  _ctx.applyObj.comments,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.applyObj.comments.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    (_ctx.v$.applyObj.comments.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.thisScreen!='Avoid' && _ctx.thisScreen!='reset'&& _ctx.thisScreen!='deactive'&& (_ctx.thisScreen!='Monitered' && _ctx.residualData.statusCode!=10425))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  _cache[83] || (_cache[83] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Impact", -1)),
                                  _cache[84] || (_cache[84] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _cache[76] || (_cache[76] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.business,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.residualData.business) = $event)),
                                        options: _ctx.dbBussiness,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.business.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                            (_ctx.v$.residualData.business.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                      _cache[77] || (_cache[77] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.financial,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.residualData.financial) = $event)),
                                        options: _ctx.dbFinancial,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.financial.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            (_ctx.v$.residualData.financial.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                      _cache[78] || (_cache[78] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.operations,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.residualData.operations) = $event)),
                                        options: _ctx.dbOperations,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.operations !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.operations.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                            (_ctx.v$.residualData.operations.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      _cache[79] || (_cache[79] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.legal,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.residualData.legal) = $event)),
                                        options: _ctx.dbLegal,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.legal !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.legal.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                            (_ctx.v$.residualData.legal.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_53, [
                                    _cache[80] || (_cache[80] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.overallImpact,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.residualData.overallImpact) = $event)),
                                      options: _ctx.dbOverAllImpact,
                                      disabled: "",
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      class: "custom-multiselect w-full"
                                    }, null, 8, ["modelValue", "options"])
                                  ]),
                                  _cache[85] || (_cache[85] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Likelihood", -1)),
                                  _cache[86] || (_cache[86] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _cache[81] || (_cache[81] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.likelihood,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.residualData.likelihood) = $event)),
                                        options: _ctx.dbLikelihood,
                                        optionLabel: "key",
                                        optionValue: "value",
                                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.calculateOverallImpact())),
                                        disabled: _ctx.thisScreen=='Acceptance',
                                        placeholder: "Please select one",
                                        class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.likelihood !== ''
                                                    }])
                                      }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                      (_ctx.v$.residualData.likelihood.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                            (_ctx.v$.residualData.likelihood.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _cache[87] || (_cache[87] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Severity", -1)),
                                  _cache[88] || (_cache[88] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                  _createElementVNode("div", _hoisted_58, [
                                    _cache[82] || (_cache[82] = _createElementVNode("label", { class: "controllabel" }, "Severity", -1)),
                                    _createVNode(_component_Select, {
                                      modelValue: _ctx.residualData.severity,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.residualData.severity) = $event)),
                                      options: _ctx.dbSeverity,
                                      disabled: "",
                                      optionLabel: "key",
                                      optionValue: "value",
                                      placeholder: "Please select one",
                                      class: "custom-multiselect w-full"
                                    }, null, 8, ["modelValue", "options"])
                                  ])
                                ]))
                              : ((_ctx.thisScreen=='Monitered' && _ctx.residualData.statusCode==10425))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _cache[96] || (_cache[96] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Impact", -1)),
                                    _cache[97] || (_cache[97] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("div", _hoisted_61, [
                                        _cache[89] || (_cache[89] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                        _createVNode(_component_Select, {
                                          modelValue: _ctx.residualData.business,
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.residualData.business) = $event)),
                                          options: _ctx.dbBussiness,
                                          optionLabel: "key",
                                          optionValue: "value",
                                          placeholder: "Please select one",
                                          onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.calculateOverallImpact())),
                                          disabled: _ctx.thisScreen=='Acceptance',
                                          class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                    }])
                                        }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                        (_ctx.v$.residualData.business.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                              (_ctx.v$.residualData.business.required.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, "Required"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_64, [
                                        _cache[90] || (_cache[90] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                        _createVNode(_component_Select, {
                                          modelValue: _ctx.residualData.financial,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.residualData.financial) = $event)),
                                          options: _ctx.dbFinancial,
                                          optionLabel: "key",
                                          optionValue: "value",
                                          placeholder: "Please select one",
                                          disabled: _ctx.thisScreen=='Acceptance',
                                          onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.calculateOverallImpact())),
                                          class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.business !== ''
                                                    }])
                                        }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                        (_ctx.v$.residualData.financial.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                              (_ctx.v$.residualData.financial.required.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_66, "Required"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_67, [
                                      _createElementVNode("div", _hoisted_68, [
                                        _cache[91] || (_cache[91] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                        _createVNode(_component_Select, {
                                          modelValue: _ctx.residualData.operations,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.residualData.operations) = $event)),
                                          options: _ctx.dbOperations,
                                          optionLabel: "key",
                                          optionValue: "value",
                                          placeholder: "Please select one",
                                          disabled: _ctx.thisScreen=='Acceptance',
                                          onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.calculateOverallImpact())),
                                          class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.operations !== ''
                                                    }])
                                        }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                        (_ctx.v$.residualData.operations.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                              (_ctx.v$.residualData.operations.required.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, "Required"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_71, [
                                        _cache[92] || (_cache[92] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                        _createVNode(_component_Select, {
                                          modelValue: _ctx.residualData.legal,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.residualData.legal) = $event)),
                                          options: _ctx.dbLegal,
                                          optionLabel: "key",
                                          optionValue: "value",
                                          placeholder: "Please select one",
                                          onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.calculateOverallImpact())),
                                          disabled: _ctx.thisScreen=='Acceptance',
                                          class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.legal !== ''
                                                    }])
                                        }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                        (_ctx.v$.residualData.legal.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                              (_ctx.v$.residualData.legal.required.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_73, "Required"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_74, [
                                      _cache[93] || (_cache[93] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.overallImpact,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.residualData.overallImpact) = $event)),
                                        options: _ctx.dbOverAllImpact,
                                        disabled: "",
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        class: "custom-multiselect w-full"
                                      }, null, 8, ["modelValue", "options"])
                                    ]),
                                    _cache[98] || (_cache[98] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Likelihood", -1)),
                                    _cache[99] || (_cache[99] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                    _createElementVNode("div", _hoisted_75, [
                                      _createElementVNode("div", _hoisted_76, [
                                        _cache[94] || (_cache[94] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                        _createVNode(_component_Select, {
                                          modelValue: _ctx.residualData.likelihood,
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.residualData.likelihood) = $event)),
                                          options: _ctx.dbLikelihood,
                                          optionLabel: "key",
                                          optionValue: "value",
                                          onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.calculateOverallImpact())),
                                          disabled: _ctx.thisScreen=='Acceptance',
                                          placeholder: "Please select one",
                                          class: _normalizeClass(["custom-multiselect w-full", {
                                                        'is-invalid': _ctx.v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.residualData.likelihood !== ''
                                                    }])
                                        }, null, 8, ["modelValue", "options", "disabled", "class"]),
                                        (_ctx.v$.residualData.likelihood.$error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                              (_ctx.v$.residualData.likelihood.required.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_78, "Required"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _cache[100] || (_cache[100] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Severity", -1)),
                                    _cache[101] || (_cache[101] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                    _createElementVNode("div", _hoisted_79, [
                                      _cache[95] || (_cache[95] = _createElementVNode("label", { class: "controllabel" }, "Severity", -1)),
                                      _createVNode(_component_Select, {
                                        modelValue: _ctx.residualData.severity,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.residualData.severity) = $event)),
                                        options: _ctx.dbSeverity,
                                        disabled: "",
                                        optionLabel: "key",
                                        optionValue: "value",
                                        placeholder: "Please select one",
                                        class: "custom-multiselect w-full"
                                      }, null, 8, ["modelValue", "options"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[104] || (_cache[104] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.cancelAceeptResetBtn())),
                    class: _normalizeClass([_ctx.applyObj.comments == '' && (JSON.stringify(_ctx.residualData) == JSON.stringify(_ctx.dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary', "mr-3"])
                  }, "Reset", 10, _hoisted_81),
                  (_ctx.thisScreen == 'Acceptance')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'),
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10403)))
                      }, "Apply", 10, _hoisted_82))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'reset')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10407)))
                      }, "Apply", 10, _hoisted_83))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'deactive')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10404)))
                      }, "Apply", 10, _hoisted_84))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'Avoid')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10419)))
                      }, "Apply", 10, _hoisted_85))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'Monitered')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(_ctx.applyObj.comments == '' && (JSON.stringify(_ctx.residualData) == JSON.stringify(_ctx.dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'),
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10425)))
                      }, "Apply", 10, _hoisted_86))
                    : _createCommentVNode("", true),
                  (_ctx.thisScreen == 'Transfer')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass([_ctx.applyObj.comments == ''&& (JSON.stringify(_ctx.residualData) == JSON.stringify(_ctx.dummyresidualData))  ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10424)))
                      }, "Apply", 10, _hoisted_87))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showThreatPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.showThreatPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_88, [
              _cache[106] || (_cache[106] = _createElementVNode("h1", null, "Risk", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onCrossbtn()))
              }, _cache[105] || (_cache[105] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _cache[107] || (_cache[107] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Risk", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "disabledtextarea",
                              placeholder: "Risk",
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.riskThreatData.riskCategory) = $event)),
                              disabled: ""
                            }, null, 512), [
                              [_vModelText, _ctx.riskThreatData.riskCategory]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("div", null, [
                              _cache[108] || (_cache[108] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "disabledinputboxstyling",
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.riskThreatData.threatSource) = $event)),
                                disabled: "",
                                placeholder: "Threat Source"
                              }, null, 512), [
                                [_vModelText, _ctx.riskThreatData.threatSource]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _createElementVNode("div", null, [
                              _cache[109] || (_cache[109] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "disabledinputboxstyling",
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.riskThreatData.threatCategory) = $event)),
                                disabled: "",
                                placeholder: "Threat Category"
                              }, null, 512), [
                                [_vModelText, _ctx.riskThreatData.threatCategory]
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("div", null, [
                              _cache[110] || (_cache[110] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "disabledinputboxstyling",
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.riskThreatData.risk) = $event)),
                                placeholder: "Risk",
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, _ctx.riskThreatData.risk]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("div", null, [
                              _cache[111] || (_cache[111] = _createElementVNode("label", { class: "controllabel" }, "Threat Event", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "disabledinputboxstyling",
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.riskThreatData.threatEvent) = $event)),
                                placeholder: "Threat Event",
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, _ctx.riskThreatData.threatEvent]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("button", {
                    class: "filterButton",
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.editRiskThreatData(_ctx.riskThreatData.mappedRisk, _ctx.riskThreatData._id)))
                  }, "Edit")
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.openRiskPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.openRiskPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_101, [
              _cache[113] || (_cache[113] = _createElementVNode("h1", null, "Risk Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onCrossbtn()))
              }, _cache[112] || (_cache[112] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, [
                          _createElementVNode("div", _hoisted_108, [
                            _cache[115] || (_cache[115] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Risk", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                        'is-invalid': _ctx.v$.riskThreatData.risk.$error||_ctx.displayErrorMessageOfRisk
                                                    }]),
                                    placeholder: "Risk",
                                    onInput: _cache[42] || (_cache[42] = ($event: any) => (_ctx.restrictCharacters('Risk'))),
                                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.riskThreatData.risk) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.risk,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.risk.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                        (_ctx.v$.riskThreatData.risk.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_111, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfRisk == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, _cache[114] || (_cache[114] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(_ctx.riskThreatData.risk||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("div", _hoisted_115, [
                            _createElementVNode("div", null, [
                              _cache[117] || (_cache[117] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                              (_ctx.riskThreatData.statusCode==10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: _ctx.riskThreatData.riskCategory,
                                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.riskThreatData.riskCategory) = $event)),
                                      suggestions: _ctx.searchRiskCategoryList,
                                      onComplete: _ctx.asyncRiskCategoryDataFind,
                                      onItemSelect: _ctx.selectedRiskCategoryOption,
                                      placeholder: "Risk Category",
                                      field: "label",
                                      class: _normalizeClass(["w-full", {
                                                            'p-invalid': _ctx.v$.riskThreatData.riskCategory.$error,
                                                            'has-options': _ctx.searchRiskCategoryList && _ctx.searchRiskCategoryList.length > 0,
                                                            'no-options': !_ctx.searchRiskCategoryList.length && _ctx.searchValue !== '',
                                                        }])
                                    }, {
                                      empty: _withCtx(() => _cache[116] || (_cache[116] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"]),
                                    (_ctx.v$.riskThreatData.riskCategory.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                          (_ctx.v$.riskThreatData.riskCategory.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_118, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_119, _toDisplayString(_ctx.riskThreatData.riskCategory||'N/A'), 1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_120, [
                            _cache[119] || (_cache[119] = _createElementVNode("label", { class: "controllabel" }, "Risk Owner", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.riskThreatData.riskOwner,
                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.riskThreatData.riskOwner) = $event)),
                                    suggestions: _ctx.userOptions,
                                    onComplete: _ctx.asyncFind,
                                    optionLabel: "label",
                                    optionValue: "value",
                                    forceSelection: "",
                                    placeholder: "Risk Owner",
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                        'p-invalid': _ctx.v$.riskThreatData.riskOwner.$error,
                                                        'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                                        'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
                                                    }])
                                  }, {
                                    empty: _withCtx(() => _cache[118] || (_cache[118] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                                  (_ctx.v$.riskThreatData.riskOwner.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                        (_ctx.v$.riskThreatData.riskOwner.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_123, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_124, _toDisplayString(_ctx.riskThreatData.riskOwner?.label||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_125, [
                          _createElementVNode("div", _hoisted_126, [
                            _cache[121] || (_cache[121] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Threat", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.riskThreatData.threatEvent.$error||_ctx.displayErrorMessageOfThreat
                                                }]),
                                    placeholder: "Threat",
                                    onInput: _cache[46] || (_cache[46] = ($event: any) => (_ctx.restrictCharacters('Threat'))),
                                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.riskThreatData.threatEvent) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.threatEvent,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.threatEvent.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                        (_ctx.v$.riskThreatData.threatEvent.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_129, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfThreat == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_130, _cache[120] || (_cache[120] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_131, _toDisplayString(_ctx.riskThreatData.threatEvent||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_132, [
                          _createElementVNode("div", _hoisted_133, [
                            _cache[123] || (_cache[123] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.riskThreatData.threatSource,
                                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.riskThreatData.threatSource) = $event)),
                                    suggestions: _ctx.searchThreatSourceList,
                                    onComplete: _ctx.asyncthreatSourceDataFind,
                                    onItemSelect: _ctx.selectedThreatSourceOption,
                                    placeholder: "Threat Source",
                                    field: "label",
                                    class: _normalizeClass(["w-full", {
                                                            'has-options': _ctx.searchThreatSourceList && _ctx.searchThreatSourceList.length > 0,
                                                            'no-options': !_ctx.searchThreatSourceList.length && _ctx.searchValue !== '',
                                                        }])
                                  }, {
                                    empty: _withCtx(() => _cache[122] || (_cache[122] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Source Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_135, _toDisplayString(_ctx.riskThreatData.threatSource||'N/A'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_136, [
                            _cache[125] || (_cache[125] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: _ctx.riskThreatData.threatCategory,
                                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.riskThreatData.threatCategory) = $event)),
                                    suggestions: _ctx.searchThreatCategoryList,
                                    onComplete: _ctx.asyncthreatCategoryDataFind,
                                    onItemSelect: _ctx.selectedOption,
                                    placeholder: "Threat Category",
                                    field: "label",
                                    class: _normalizeClass(["w-full", {
                                                    'has-options': _ctx.searchThreatCategoryList && _ctx.searchThreatCategoryList.length > 0,
                                                    'no-options': !_ctx.searchThreatCategoryList.length && _ctx.searchValue !== '',
                                                }])
                                  }, {
                                    empty: _withCtx(() => _cache[124] || (_cache[124] = [
                                      _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(_ctx.riskThreatData.threatCategory), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_139, [
                          _createElementVNode("div", _hoisted_140, [
                            _cache[127] || (_cache[127] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Vulnerability", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.riskThreatData.vulnerability.$error||_ctx.displayErrorMessageOfVulnerability
                                                }]),
                                    placeholder: "Vulnerability",
                                    onInput: _cache[50] || (_cache[50] = ($event: any) => (_ctx.restrictCharacters('Vulnerability'))),
                                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.riskThreatData.vulnerability) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.vulnerability,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.vulnerability.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                        (_ctx.v$.riskThreatData.vulnerability.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_143, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfVulnerability == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_144, _cache[126] || (_cache[126] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_145, _toDisplayString(_ctx.riskThreatData.vulnerability||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_146, [
                          _createElementVNode("div", _hoisted_147, [
                            _cache[129] || (_cache[129] = _createElementVNode("label", {
                              for: "Risk",
                              class: "controllabel"
                            }, "Risk Assessment", -1)),
                            (_ctx.riskThreatData.statusCode==10401|| _ctx.addingRisk==true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.riskThreatData.riskAssessment.$error||_ctx.displayErrorMessageOfAssessment
                                                }]),
                                    placeholder: "Risk Assessment",
                                    onInput: _cache[52] || (_cache[52] = ($event: any) => (_ctx.restrictCharacters('Assessment'))),
                                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.riskThreatData.riskAssessment) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.riskThreatData.riskAssessment,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.riskThreatData.riskAssessment.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                        (_ctx.v$.riskThreatData.riskAssessment.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_150, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfAssessment == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_151, _cache[128] || (_cache[128] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_152, _toDisplayString(_ctx.riskThreatData.riskAssessment||'N/A'), 1))
                          ])
                        ]),
                        _cache[137] || (_cache[137] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Impact", -1)),
                        _cache[138] || (_cache[138] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_153, [
                          _createElementVNode("div", _hoisted_154, [
                            _cache[130] || (_cache[130] = _createElementVNode("label", { class: "controllabel" }, "Startegic", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.business,
                                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.riskThreatData.business) = $event)),
                                    options: _ctx.dbBussiness,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[55] || (_cache[55] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.business.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.business === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.business !== ''

                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.business.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                        (_ctx.v$.riskThreatData.business.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_157, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0  && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_158, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.business,1) || 'N/A'), 1))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_159, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.business,1)||'N/A'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_160, [
                            _cache[131] || (_cache[131] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.financial,
                                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.riskThreatData.financial) = $event)),
                                    options: _ctx.dbFinancial,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[57] || (_cache[57] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.financial.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.financial === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.financial !== ''
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.financial.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                        (_ctx.v$.riskThreatData.financial.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_163, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_164, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.financial,2) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_165, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.financial,2)), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_166, [
                          _createElementVNode("div", _hoisted_167, [
                            _cache[132] || (_cache[132] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.operations,
                                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.riskThreatData.operations) = $event)),
                                    options: _ctx.dbOperations,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[59] || (_cache[59] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.operations.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.operations === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.operations !== ''
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.operations.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                                        (_ctx.v$.riskThreatData.operations.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_170, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_171, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.operations,3) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_172, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.operations,3)||'N/A'), 1))
                          ]),
                          _createElementVNode("div", _hoisted_173, [
                            _cache[133] || (_cache[133] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.legal,
                                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.riskThreatData.legal) = $event)),
                                    options: _ctx.dbLegal,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[61] || (_cache[61] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.legal.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.legal === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.legal !== ''
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.legal.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                        (_ctx.v$.riskThreatData.legal.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_176, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_177, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.legal,4) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_178, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.legal,4)||'N/A'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_179, [
                          _cache[134] || (_cache[134] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                          (_ctx.riskThreatData.statusCode==10401)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.riskThreatData.overallImpact,
                                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.riskThreatData.overallImpact) = $event)),
                                  options: _ctx.dbSeverity,
                                  disabled: "",
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_181, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.overallImpact,6)||'N/A'), 1))
                        ]),
                        _cache[139] || (_cache[139] = _createElementVNode("h1", { class: "upperspacing" }, "Revised Likelihood", -1)),
                        _cache[140] || (_cache[140] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_182, [
                          _createElementVNode("div", _hoisted_183, [
                            _cache[135] || (_cache[135] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                            (_ctx.riskThreatData.statusCode==10401)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.riskThreatData.likelihood,
                                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.riskThreatData.likelihood) = $event)),
                                    options: _ctx.dbLikelihood,
                                    optionLabel: "key",
                                    optionValue: "value",
                                    placeholder: "Please select one",
                                    onChange: _cache[64] || (_cache[64] = ($event: any) => (_ctx.calculateOverallImpact())),
                                    class: _normalizeClass(["custom-multiselect w-full", {
                                                    'is-invalid': _ctx.v$.riskThreatData.likelihood.$error,
                                                    'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.likelihood === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.likelihood !== ''
                                                }])
                                  }, null, 8, ["modelValue", "options", "class"]),
                                  (_ctx.v$.riskThreatData.likelihood.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                        (_ctx.v$.riskThreatData.likelihood.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_186, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.riskThreatData.residual && _ctx.riskThreatData.residual.length > 0 && _ctx.riskThreatData.action!=10419 && _ctx.riskThreatData.statusCode!=10401)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_187, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.residual[_ctx.riskThreatData.residual.length - 1]?.likelihood,5) || 'N/A'), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_188, _toDisplayString(_ctx.lablesData(_ctx.riskThreatData.likelihood,5)||'N/A'), 1))
                          ])
                        ]),
                        _cache[141] || (_cache[141] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Severity", -1)),
                        _cache[142] || (_cache[142] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_189, [
                          _cache[136] || (_cache[136] = _createElementVNode("label", { class: "controllabel" }, "Severity", -1)),
                          _createVNode(_component_Select, {
                            modelValue: _ctx.riskThreatData.severity,
                            "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.riskThreatData.severity) = $event)),
                            options: _ctx.dbSeverity,
                            disabled: "",
                            optionLabel: "key",
                            optionValue: "value",
                            placeholder: "Please select one",
                            class: "custom-multiselect w-full"
                          }, null, 8, ["modelValue", "options"])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.riskThreatData.statusCode==10401)
                ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                    _cache[143] || (_cache[143] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_191, [
                      _createElementVNode("button", {
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(["btnprimary mr-2 gap-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.onCancelRiskData()))
                      }, "Reset", 10, _hoisted_192),
                      _createElementVNode("button", {
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.addOrUpdaterisk(_ctx.riskThreatData)))
                      }, "Update", 10, _hoisted_193)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPriorityPopUp)
      ? (_openBlock(), _createBlock(_component_popup, { key: 3 }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_194, [
              _cache[145] || (_cache[145] = _createElementVNode("h1", null, "Risk Prioritize", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.closePriorityPopup()))
              }, _cache[144] || (_cache[144] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_195, [
              _createElementVNode("div", _hoisted_196, [
                _createElementVNode("div", _hoisted_197, [
                  _createElementVNode("div", _hoisted_198, [
                    _createElementVNode("div", _hoisted_199, [
                      _cache[146] || (_cache[146] = _createElementVNode("label", {
                        class: "controllabel font-normal text-sm mb-1",
                        for: "vulnerability"
                      }, "Risk Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.riskPriorityShow.risk) = $event)),
                        disabled: "",
                        placeholder: "Name of the Risk",
                        id: "id",
                        class: _normalizeClass(["disabledinputboxstyling", {
                                            'is-invalid': _ctx.v$.riskPriorityShow.risk.$error
                                        }])
                      }, null, 2), [
                        [_vModelText, _ctx.riskPriorityShow.risk]
                      ]),
                      (_ctx.v$.riskPriorityShow.risk.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                            (_ctx.v$.riskPriorityShow.risk.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_201, "Risk name is required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_202, [
                      _cache[147] || (_cache[147] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                      _createVNode(_component_Select, {
                        modelValue: _ctx.riskPriorityShow.priority,
                        "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.riskPriorityShow.priority) = $event)),
                        options: _ctx.dbPriority,
                        optionLabel: "key",
                        optionValue: "value",
                        class: "inputboxstyling w-full"
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    (_ctx.v$.riskPriorityShow.priority.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                          (_ctx.v$.riskPriorityShow.priority.required.$invalid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_204, "Please change priority"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (this.riskPriorityShow.priority!==this.priorityDummy.priority)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                          _createElementVNode("div", _hoisted_206, [
                            _createElementVNode("div", _hoisted_207, [
                              _cache[148] || (_cache[148] = _createElementVNode("label", {
                                for: "Risk",
                                class: "controllabel"
                              }, "Justification", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': _ctx.v$.riskPriorityShow.justification.$error
                                        }]),
                                placeholder: "Justification",
                                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.riskPriorityShow.justification) = $event))
                              }, null, 2), [
                                [
                                  _vModelText,
                                  _ctx.riskPriorityShow.justification,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ])
                          ]),
                          (_ctx.v$.riskPriorityShow.justification.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                (_ctx.v$.riskPriorityShow.justification.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_209, "Justification is required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _cache[149] || (_cache[149] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
              _createElementVNode("div", _hoisted_210, [
                _createElementVNode("button", {
                  disabled: _ctx.clickOnButton,
                  class: _normalizeClass(["btnprimary mr-1.5", JSON.stringify(_ctx.riskPriorityShow) !== JSON.stringify(_ctx.priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                  onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.cancelPriorityBtn()))
                }, "Reset", 10, _hoisted_211),
                _createElementVNode("button", {
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.addOrUpdatePriority())),
                  class: _normalizeClass(JSON.stringify(_ctx.riskPriorityShow) !== JSON.stringify(_ctx.priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none')
                }, "Save", 10, _hoisted_212)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}